import axios from "axios";
import { useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { MdEditSquare } from "react-icons/md";
import uploadFileToS3 from "../../fileuploader/fileUploader";
import { API_URL } from "../../url/api";
import { FaExternalLinkAlt } from "react-icons/fa";

interface DoctorAccountProps {
  profile: string | null;
  specialities: string | null;
  price: number;

  id: number;
  therapist: {
    id: number;
    name: string;
    email: string;
    phone: string;
    attach_cv: string;
    is_email_send: boolean;
    created_at: string;
  };
  created_at: string;
}

interface DoctorDataAccountProps {
  profile: string | null;
  specialities: string | null;
  price: number;
  name: string;
  phonenumber: string;
}

const DcotorAccount = () => {
  const [originalData, setOriginalData] = useState<DoctorDataAccountProps>({
    name: "",
    phonenumber: "",
    profile: "",
    specialities: "",
    price: 0,
  });
  const [data, setData] = useState<DoctorDataAccountProps>({
    name: "",
    phonenumber: "",
    profile: "",
    specialities: "",
    price: 0,
  });

  const [file, setFile] = useState<File>();
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [editmode, setEditmode] = useState(false);

  const fetchData = async () => {
    const doctorId = localStorage.getItem("doctorId");

    if (!doctorId) {
      setError("Doctor ID not found");
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.get<DoctorAccountProps>(
        `${API_URL}doctors/${doctorId}/`
      );
      if (response.status !== 200) {
        setError("Error fetching data");
        return;
      }
      setOriginalData({
        name: response.data.therapist.name,
        phonenumber: response.data.therapist.phone,
        profile: response.data.profile,
        specialities: response.data.specialities,
        price: response.data.price,
      });
      setData({
        name: response.data.therapist.name,
        phonenumber: response.data.therapist.phone,
        profile: response.data.profile,
        specialities: response.data.specialities,
        price: response.data.price,
      });
    } catch (error) {
      setError("Error fetching data");
      console.error("Error fetching session data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  function compareData() {
    if (!originalData || !data) return false;
    return (
      originalData.name === data.name &&
      originalData.phonenumber === data.phonenumber &&
      originalData.profile === data.profile &&
      originalData.specialities === data.specialities &&
      originalData.price === data.price &&
      file === undefined
    );
  }

  const uploadFile = async () => {
    if (file) {
      const res = await uploadFileToS3(file, "shvesa", file.name);
      console.log("🚀 ~ res:", res);
      return res;
      // if (res) {
      //   setData({ ...data, profile: res });
      //   console.log("🚀 ~ uploadFile ~ res:", res);
      // }
    }
  };

  const handleImageChange = async (
    e: React.ChangeEvent<HTMLInputElement & EventTarget & { files: FileList }>
  ) => {
    const file = e.target.files[0];
    console.log("🚀 ~ DcotorAccount ~ file:", file);
    setFile(file);
  };

  function handleEditMode() {
    setEditmode((prev) => {
      setData(originalData);
      setError("");
      return !prev;
    });
  }

  const handleUpdate = async () => {
    const doctorId = localStorage.getItem("doctorId");
    if (!doctorId) {
      setError("Doctor ID not found");
      return;
    }
    setIsLoading(true);
    try {
      if (file) {
        const profile = await uploadFile();
        if (profile) {
          data.profile = profile;
        }
      }

      console.log("🚀 ~ handleUpdate ~ data", data);

      const response = await axios.put<DoctorAccountProps>(
        `${API_URL}doctors/${doctorId}/`,
        data
      );
      if (response.status !== 200) {
        setError("Error putting data");
        return;
      }
      fetchData();
    } catch (error) {
      setError("Error putting data");
      console.error("Error putting session data:", error);
    } finally {
      setIsLoading(false);
      handleEditMode();
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl">
      <div className="flex justify-between items-center py-4">
        <h2 className="text-2xl font-semibold text-gray-900">
          Account settings
        </h2>

        <div className="flex flex-row items-center justify-center space-x-6 ">
        <a className=" flex flex-row space-x-2 items-center" href="/forgot-password">
            <p className="text-md items-center">Reset Password</p>
            <FaExternalLinkAlt className="w-4 h-4" />
          </a>

        <button
          className="bg-blue-500 text-white px-4  rounded-lg p-2"
          onClick={() => (window.location.href = "/logout")}
        >
          <div className="flex flex-row justify-center items-center space-x-2">
            <p>Logout</p>
          </div>
        </button>

        </div>
      </div>
      <div className="bg-white p-4 shadow-sm rounded-lg my-4 relative border">
        <div className="absolute top-5 right-5">
          {!editmode ? (
            <MdEditSquare
              size={20}
              className="cursor-pointer"
              onClick={handleEditMode}
            />
          ) : (
            <IoIosCloseCircle
              size={20}
              className="cursor-pointer"
              onClick={handleEditMode}
            />
          )}
        </div>

        {!editmode && (
          <div className="flex justify-center items-center my-6">
            <img
              src={data?.profile || ""}
              alt="profile"
              className="w-60 h-60 md:w-40 md:h-40 rounded-full border"
            />
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 p-6">
          <div className="my-2">
            <p className="font-semibold mb-2">Name</p>
            {editmode ? (
              <input
                type="text"
                value={data?.name || ""}
                onChange={(e) => setData({ ...data, name: e.target.value })}
                className="w-full p-2 border border-gray-300 rounded-lg"
              />
            ) : (
              <p className="font-medium text-lg">{data?.name}</p>
            )}
          </div>

          <div className="my-2">
            <p className="font-semibold mb-2">Specialities</p>
            {editmode ? (
              <input
                type="text"
                value={data?.specialities || ""}
                onChange={(e) =>
                  setData({ ...data, specialities: e.target.value })
                }
                className="w-full p-2 border border-gray-300 rounded-lg"
              />
            ) : (
              <p className="font-medium text-lg">{data?.specialities}</p>
            )}
          </div>

          <div className="my-2">
            <p className="font-semibold mb-2">Phone number</p>
            {editmode ? (
              <input
                type="text"
                value={data?.phonenumber}
                onChange={(e) =>
                  setData({ ...data, phonenumber: e.target.value })
                }
                className="w-full p-2 border border-gray-300 rounded-lg"
              />
            ) : (
              <p className="font-medium text-lg">{data?.phonenumber}</p>
            )}
          </div>

          <div className="my-2">
            <p className="font-semibold mb-2">Price</p>
            {editmode ? (
              <input
                type="number"
                value={data?.price}
                onChange={(e) =>
                  setData({ ...data, price: parseInt(e.target.value) })
                }
                className="w-full p-2 border border-gray-300 rounded-lg"
              />
            ) : (
              <p className="font-medium text-lg">{data?.price}</p>
            )}
          </div>

          

          {editmode && (
            <div className="my-2">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="phone"
              >
                Upload Profile
              </label>
              <div className="flex items-center space-x-6">
                <label className="block">
                  <span className="sr-only">Choose Profile</span>
                  <input
                    id="attach_cv"
                    required
                    type="file"
                    accept="application/image"
                    className="block w-full text-sm text-slate-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-primary-50 file:text-gray-700
                            hover:file:bg-gray-100
                          "
                    onChange={handleImageChange}
                  />
                </label>
              </div>
            </div>
          )}

          
        </div>
        {editmode && (
          <div className="my-2 flex flex-col space-y-6 md:space-y-0 px-5 md:flex-row justify-end">
            {!compareData() && (
              <button
                type="button"
                className="bg-primary w-full md:w-44 rounded-lg px-4 py-2 text-white text-lg"
                onClick={handleUpdate}
              >
                Update
              </button>
            )}
            <button
              type="button"
              className=" w-full md:w-44 rounded-lg px-4 py-2 text-gray-500 text-lg"
              onClick={handleEditMode}
            >
              Cancel
            </button>
          </div>
        )}
        <p className="text-red-500 py-4 px-6 text-center">{error}</p>
      </div>
    </div>
  );
};

export default DcotorAccount;
